module.exports = __webpack_public_path__ + "img/Weapon_219.f6ce6fbc.png";